"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.makeEmptyLegalEntity = void 0;
function makeEmptyLegalEntity() {
    return {
        name: '',
        email: '',
        phone: '',
    };
}
exports.makeEmptyLegalEntity = makeEmptyLegalEntity;
//# sourceMappingURL=LegalEntity.js.map